import { render, staticRenderFns } from "./TransferredStu.vue?vue&type=template&id=0a464b38&"
import script from "./TransferredStu.vue?vue&type=script&lang=js&"
export * from "./TransferredStu.vue?vue&type=script&lang=js&"
import style0 from "./TransferredStu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports